import type { Ref } from 'vue'

export function refFiltered<T>(value: Ref<T>, filterFn: (val: T) => boolean): Readonly<Ref<T>> {
  const initialValue = value.value
  const filtered = ref(filterFn(initialValue) ? initialValue : undefined) as Ref<T>

  watch(value, newValue => filterFn(newValue) && (filtered.value = newValue))

  return filtered
}
